<template>
  <b-sidebar :id="'sidebar-report-' + classroom.id" :title="classroom.name" sidebar-class="bb-offcanvas-panel full"
             width="100%" v-on:change="onLtiPanelVisibilityChange" v-on:shown="initReports(classroom.id)" v-on:hidden="clearReports"
             bg-variant="white" right backdrop-variant="dark" backdrop no-header shadow>
    <template #default="{ hide }">
      <div class="bb-offcanvas-panel-wrap">
        <div class="panel-main-content" v-if="!show_report">
          <header class="page-header page-header-collapsed">
            <div class="page-title-wrapper page-title-report-sidebar">
              <h1 class="page-title">{{ $t("sessions.reports.name") }}: <bdi>{{classroom.name}}</bdi></h1>
            </div>
            <button class="bb-close" v-on:click="hide">
              <span>{{ $t("buttons.close") }}</span><i class="isax isax-close-circle"/>
            </button>
          </header>
          <div id="body-content" class="body-content instances-container">
            <div v-if="!loading" class="full-width-content--small div-content-report-sidebar">
              <div v-if="!reports.length" class="no-content no-results">
                <span class="image pb-3">
                  <img class="site-logo" src="/static/img/miroodles_sticker.png">
                </span>
                <span class="no-content-title">{{ $t("sessions.reports.noreportssession") }}</span>
              </div>
              <table v-if="reports.length" class="content-table report-table">
                <tbody>
                  <tr class="content-table__header content-table__header--shadow">
                    <th class="medium-2 width-10">{{ $t("sessions.reports.hourstart") }}</th>
                    <th class="medium-2 width-10">{{ $t("sessions.reports.hourfinish") }}</th>
                    <th class="medium-1 width-5">{{ $t("recordings.duration") }}</th>
                    <th class="medium-1 width-5">{{ $t("sessions.reports.attendants") }}</th>
                    <th class="medium-1">{{ $t("sessions.reports.assistance") }}</th>
                  </tr>
                  <tr v-for="report in reports" v-bind:key="report.id" class="element-list-row" bb-attendance-instance-row>
                    <td class="date">
                      <span class="inline-column-title">{{ $t("sessions.reports.hourstart") }}:</span>
                      <span>{{ report.startTime | moment("D/M/YY HH:mm") }}</span>
                    </td>
                    <td class="date">
                      <span class="inline-column-title">{{ $t("sessions.reports.hourfinish") }}:</span>
                      <span>{{ report.endTime | moment("D/M/YY HH:mm") }}</span>
                    </td>
                    <td>
                      <span class="inline-column-title">{{ $t("recordings.duration") }}:</span>
                      <span>{{ report.duration }}</span>
                    </td>
                    <td>
                      <span class="inline-column-title">{{ $t("sessions.reports.attendants") }}:</span>
                      <span>{{ report.attendeesCount }}</span>
                    </td>
                    <td class="attendance-column">
                      <button class="button text" @click="showReport(report, true)">
                        {{ $t("sessions.reports.seereport") }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="panel-main-content" v-else>
          <header class="page-header page-header-collapsed">
            <div class="page-title-wrapper">
              <a class="button button--icon -inverse previous-panel has-tooltip" id="tooltip-back" @click="hideReport()">
                <i class="isax isax-arrow-left"></i>
              </a>
              <b-tooltip target="tooltip-back" triggers="hover">
                {{ $t("sessions.reports.backward") }}
              </b-tooltip>
              <h1 class="page-title">{{ $t("sessions.reports.sessionreport") }} <bdi>{{classroom.name}}</bdi></h1>
            </div>
            <button class="bb-close" v-on:click="hide">
              <span>{{ $t("buttons.close") }}</span><i class="isax isax-close-circle"/>
            </button>
          </header>
          <div class="content-container container-fluid pt-2">
            <div class="row">
              <aside class="panel-aside col-sm-12 col-md-3 col-lg-2 redirect-detail aside-report-detail">
                <ul class="tool-list">
                  <li>
                    <h3>{{ $t("sessions.reports.sessiondetails") }}</h3>
                    <div class="tool-list-info instance-detail">
                      <div>
                        <span class="tool-list-title single-day-date">
                          {{ report.startTime | moment("dddd, D [de] MMMM [de] YYYY") }}
                        </span>
                        <div class="tool-list-detail">
                          {{ report.startTime | moment("HH:mm") }}
                          <span>-</span>
                          {{ report.endTime | moment("HH:mm") }}
                        </div>
                      </div>
                      <h3>
                        <span>{{ $t("sessions.reports.attendants") }}</span>
                      </h3>
                      <span class="tool-list-title">
                        <span>{{ report.attendeesCount }}</span>
                      </span>
                    </div>
                  </li>
                  <li>
                    <h3>{{ $t("sessions.reports.tools") }}</h3>
                    <div class="tool-list-export">
                      <div class="tool-list-info">
                        <button class="tool-list-csv-button button--text d-flex align-items-center">
                          <i class="isax isax-document-download"></i>
                          <download-csv :data="report_attendees_csv" :labels="report_attendees_csv_labels" :name="classroom.name + '.csv'">
                            {{ $t("sessions.reports.exportreportCSV") }}
                          </download-csv>
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </aside>
              <div class="panel-content col-sm-12 col-md-9 col-lg-10 panel-content-report-detail">
                <div class="full-width-content--small attendees-list">
                  <table v-if="report_attendees" class="content-table report-detail-table" id="report-content-table">
                    <tbody>
                      <tr class="content-table__header content-table__header--shadow">
                        <th>{{ $t("sessions.name") }}</th>
                        <th>{{ $t("sessions.reports.role") }}</th>
                        <th>{{ $t("sessions.reports.firstconnection") }}</th>
                        <th>{{ $t("sessions.reports.lastconnection") }}</th>
                        <th>{{ $t("sessions.reports.totaltime") }}</th>
                        <th>{{ $t("sessions.reports.entries") }}</th>
                      </tr>
                      <tr v-for="attendee in report_attendees.results" v-bind:key="attendee.displayName" class="element-list-row" bb-attendee-row>
                        <td class="break-word content-table__emphasis">
                          <span class="inline-column-title span-text-table-report-detail">{{ $t("sessions.name") }}:</span>
                          <span class="span-text-table-report-detail">{{ attendee.displayName }}</span>
                        </td>
                        <td>
                          <span class="inline-column-title">{{ $t("sessions.reports.role") }}:</span>
                          <span>{{ friendlyRole(attendee.role) }}</span>
                        </td>
                        <td>
                          <span class="inline-column-title">{{ $t("sessions.reports.firstconnection") }}:</span>
                          <span>{{ attendee.firstJoin | moment("HH:mm") }}</span>
                        </td>
                        <td>
                          <span class="inline-column-title">{{ $t("sessions.reports.lastconnection") }}:</span>
                          <span>{{ attendee.lastLeave | moment("HH:mm") }}</span>
                        </td>
                        <td>
                          <span class="inline-column-title">{{ $t("sessions.reports.totaltime") }}:</span>
                          <span>{{ msToTime(attendee.totalActive) }}</span>
                        </td>
                        <td>
                          <span class="inline-column-title">{{ $t("sessions.reports.entries") }}:</span>
                          <span>{{ attendee.attendance.length }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <footer v-if="report_pagination.limit < report.attendeesCount" class="panel-footer session-attendee-pagination">
                  <b-pagination
                    v-model="report_pagination_current"
                    :total-rows="report.attendeesCount"
                    :per-page="report_pagination.limit"
                    align="center"
                    aria-controls="report-content-table"
                  ></b-pagination>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import KeyboardReturnIcon from 'vue-material-design-icons/KeyboardReturn.vue'
import CloudDownloadOutlineIcon from 'vue-material-design-icons/CloudDownloadOutline.vue'
import FileIcon from 'vue-material-design-icons/File.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import jwtMixin from '../../../mixins/jwtMixin'
import ltiFrameMixin from '../../../mixins/ltiFrameMixin'

export default {
  name: 'ReportSidebar',
  components: {CloseIcon, KeyboardReturnIcon, CloudDownloadOutlineIcon, FileIcon},
  mixins: [utilitiesMixin, jwtMixin, ltiFrameMixin],
  props: ['classroom', 'iconColor', 'returnIconColor'],
  mounted () {
    this.$moment.locale('es')
  },
  created () {
    this.$i18n.locale = this.jwtLanguage()
  },
  data () {
    return {
      loading: false,
      reports: [],
      show_report: null,
      report: null,
      report_attendees: null,
      report_attendees_csv_labels: {
        userId: this.$i18n.t('sessions.reports.unirid'),
        displayName: this.$i18n.t('sessions.name'),
        role: this.$i18n.t('sessions.reports.role'),
        firstJoin: this.$i18n.t('sessions.reports.firstconnection'),
        lastLeave: this.$i18n.t('sessions.reports.lastconnection'),
        totalActive: this.$i18n.t('sessions.reports.totaltime'),
        joins: this.$i18n.t('sessions.reports.entries')
      },
      current_report: null,
      report_attendees_csv: [],
      report_pagination_current: 1,
      report_pagination: {
        limit: 10,
        offset: 0
      }
    }
  },
  watch: {
    report_pagination_current: {
      handler: function (value) {
        // CMM: se establece la paginación acorde a la página activada
        this.report_pagination.offset = this.report_pagination.limit * (this.report_pagination_current - 1)
        this.showReport(this.current_report, false)
      }
    }
  },
  methods: {
    initReports (classroomId) {
      let vueComponent = this
      this.report_pagination = {
        limit: 10,
        offset: 0
      }
      // CMM: Se recuperan los informes de la clase
      window.axios.get('reports/' + classroomId).then((response) => {
        vueComponent.reports = response.data
        vueComponent.reports.forEach(function (report) {
          let duration = window.moment.utc(window.moment(report.endTime).diff(window.moment(report.startTime))).format('HH:mm:ss')
          vueComponent.$set(report, 'duration', duration)
        })

        this.loading = false
      })
    },
    showReport (report, withCsv) {
      let vueComponent = this
      this.show_report = true
      this.current_report = report
      this.report = report
      // CMM: Se recuperan los accesos de asistentes para el informe
      vueComponent.$set(this.report_pagination, 'reportId', report.id)
      window.axios.get('reports/' + this.classroom.id + '/attendees', {params: this.report_pagination}).then((response) => {
        vueComponent.report_attendees = response.data
        vueComponent.report_attendees.results.forEach(function (attendee) {
          let totalActive = 0
          attendee.attendance.forEach(function (attendance) {
            if (attendee.firstJoin === undefined || window.moment(attendance.joined).isBefore(attendee.firstJoin)) {
              vueComponent.$set(attendee, 'firstJoin', attendance.joined)
            }
            if (attendee.lastLeave === undefined || window.moment(attendance.left).isAfter(attendee.lastLeave)) {
              vueComponent.$set(attendee, 'lastLeave', attendance.left)
            }
            totalActive += attendance.duration * 1000
            vueComponent.$set(attendee, 'totalActive', totalActive)
          })
        })
      })
      // CMM: Se preparan los datos para la descarga del CSV
      let csvReportParams = {
        reportId: report.id
      }
      if (withCsv) {
        window.axios.get('reports/' + this.classroom.id + '/attendees', {params: csvReportParams}).then((response) => {
          vueComponent.report_attendees_csv = []
          let reportCsvAttendees = response.data
          reportCsvAttendees.results.forEach(function (attendee) {
            let totalActive = 0
            attendee.attendance.forEach(function (attendance) {
              if (attendee.firstJoin === undefined || window.moment(attendance.joined).isBefore(attendee.firstJoin)) {
                vueComponent.$set(attendee, 'firstJoin', attendance.joined)
              }
              if (attendee.lastLeave === undefined || window.moment(attendance.left).isAfter(attendee.lastLeave)) {
                vueComponent.$set(attendee, 'lastLeave', attendance.left)
              }
              totalActive += attendance.duration * 1000
              vueComponent.$set(attendee, 'totalActive', totalActive)
            })
            // CMM: Se compone el registro para la exportación a CSV
            let csvAttendee = {
              userId: attendee.sisId,
              displayName: attendee.displayName,
              role: vueComponent.friendlyRole(attendee.role),
              firstJoin: window.moment(attendee.firstJoin).format('YYYY-MM-DD HH:mm:ss'),
              lastLeave: window.moment(attendee.lastLeave).format('YYYY-MM-DD HH:mm:ss'),
              totalActive: vueComponent.msToTime(attendee.totalActive),
              joins: attendee.attendance.length
            }
            vueComponent.report_attendees_csv.push(csvAttendee)
          })
        })
      }
    },
    hideReport () {
      this.initReports(this.classroom.id)
      this.report = null
      this.show_report = false
      this.report_attendees = null
    },
    clearReports () {
      this.reports = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/SessionsModals/ReportSidebar.vue